import styled from "styled-components";
import { themes } from "../../../Utils/themes";
import { device } from "../../../Utils/device";
import { Link } from "react-router-dom";

export const PCHeaderWrap = styled.div`
  display: none;
  @media ${device.desktop} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    width: 100%;
  }
`;

export const HeaderMenuItemWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
`;

export const MenuItemWrap = styled.div`
  display: flex;
  align-items: center;
  margin: 10px;
  padding: 3px 6px;
`;

export const LogoImg = styled.img`
  display: none;
  @media ${device.desktop} {
    display: block;
    width: 200px;
  }
`;

export const LinkIcon = styled.img`
  width: 25px;
  cursor: pointer;
`;

export const HeaderLink = styled(Link)`
  display: block;
  font-size: ${themes.textSize.l1};
  text-decoration: none;
  color: ${themes.colors.text};
  height: 100%;
  @media ${device.desktop} {
    font-size: ${themes.textSize.l2};
  }
`;
